import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground = () => {
  const [bubbles, setBubbles] = useState([]);
  
  useEffect(() => {
    // Create bubbles with random properties
    const generateBubbles = () => {
      const bubblesArray = [];
      // Drastically reduced count to prevent flickering
      const count = window.innerWidth < 768 ? 4 : 6;
      
      for (let i = 0; i < count; i++) {
        bubblesArray.push({
          id: i,
          x: Math.random() * 100, // Random position as percentage of viewport
          y: Math.random() * 100,
          size: Math.random() * 120 + 50, // Random size between 50-170px
          opacity: Math.random() * 0.08 + 0.03, // Reduced opacity even further
          duration: Math.random() * 60 + 60, // Extended duration for smoother animations
          delay: Math.random() * 10, // Random delay for animation start
          type: Math.random() > 0.7 ? 'circle' : 'blob', // 70% blobs, 30% circles
          color: Math.random() > 0.5 ? 'purple' : 'gold', // Random color
        });
      }
      
      setBubbles(bubblesArray);
    };
    
    generateBubbles();
    
    // Regenerate on resize for responsive behavior
    const handleResize = () => {
      generateBubbles();
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden pointer-events-none z-0">
      {bubbles.map((bubble) => {
        // Define color gradient based on bubble type
        const gradientColor = bubble.color === 'purple' 
          ? 'radial-gradient(circle, rgba(177, 107, 189, 0.3) 0%, rgba(177, 107, 189, 0) 70%)'
          : 'radial-gradient(circle, rgba(255, 215, 0, 0.2) 0%, rgba(255, 215, 0, 0) 70%)';
          
        // Create blob shape for some bubbles
        const blobFilter = bubble.type === 'blob' 
          ? 'blur(40px)' 
          : 'blur(20px)';
        
        return (
          <motion.div
            key={bubble.id}
            className="absolute rounded-full will-change-transform"
            style={{
              left: `${bubble.x}%`,
              top: `${bubble.y}%`,
              width: bubble.size,
              height: bubble.size,
              opacity: bubble.opacity,
              background: gradientColor,
              filter: blobFilter,
              transform: 'translate3d(0,0,0)', // Hardware acceleration
            }}
            animate={{
              x: [
                0,
                Math.random() * 50 - 25, // Further reduced movement range
                0
              ],
              y: [
                0,
                Math.random() * 50 - 25, // Further reduced movement range
                0
              ],
              scale: [1, bubble.type === 'blob' ? 1.1 : 1.05, 1], // Reduced scale change
              opacity: [
                bubble.opacity,
                bubble.opacity * 1.2,
                bubble.opacity
              ],
            }}
            transition={{
              duration: bubble.duration,
              delay: bubble.delay,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "easeInOut"
            }}
          />
        );
      })}
    </div>
  );
};

export default AnimatedBackground;